(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["faq-sidebar"] && !Shopify.designMode) return;
  try {
    // Mobile bar: bring the current page's link into view so the underline is
  // visible even when it sits past the right edge. No-op on desktop, where
  // the list doesn't overflow.
  (function () {
    function revealActive() {
      document.querySelectorAll('.faq-sidebar__nav-scroll').forEach(function (scroller) {
        var active = scroller.querySelector('.faq-sidebar__link.is-active');
        if (!active || scroller.scrollWidth <= scroller.clientWidth) return;
        var pad = parseInt(getComputedStyle(scroller).paddingLeft, 10) || 0;
        var box = scroller.getBoundingClientRect();
        var link = active.getBoundingClientRect();
        // Leave it alone if it's already fully in view (e.g. the first link).
        if (link.left >= box.left + pad && link.right <= box.right) return;
        scroller.scrollLeft += link.left - box.left - pad;
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealActive);
    } else {
      revealActive();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
